module.exports = __webpack_public_path__ + "static/media/logout.d64a550d.svg";